import ReviewSourceLogo from './review-source-logo.vue';
import ReviewScore from './review-score.vue';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
import { mapState, mapActions } from '../../store/helpers';
import {
    SET_TESTIMONIALS,
    SET_AGENT,
    SET_DISPLAY_MORELINK
} from './_store/types';
import { REVIEW_SOURCE, REVIEW_SOURCE_KEY } from './constants';
import useStore from './_store';
import { getStore } from '@/store';
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';
export default {
    components: { ReviewSourceLogo, ReviewScore },
    i18next: {
        ns: 'md-testimonial'
    },
    mixins: [spaceMixin('colorBlock'), colorMixin()],
    _getUseStore: useStore,
    asyncData: mapAsyncData(asyncData),
    data: function() {
        let config = {
            theme: 'slider-standard', // style
            title: '', // title
            showMore: true, // whether to display more Link
            moreLink: '/reviews', //more link address
            morePage: '/reviews',
            moreType: 'link',
            moreText: 'more', //more link description
            moreTarget: true, //more Link target
            source: [REVIEW_SOURCE['none']],
            ids: '', // of the comments to get id
            bgType: 'color', // background type  img / color
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            }, // Background picture
            bgColor: 'white', // background color
            maskOption: {
                showMask: true,
                maskColor: 'rgba(25,25,25,0.3)'
            },
            autoPlay: false, // Whether to turn pages automatically
            delayTime: 1500, // page turning time
            speed: 1000, // page turning speed
            slideMode: 'full', // every page turn ,full  flip a screen , single  flip one
            spaceBetween: 20, // spacing per page
            loop: false, // Whether to cycle
            fullColumn: false,
            intersection: false, // control list cross display avatar
            showLeft: false, //  Control left and right display
            displayType: '', //part / all
            displayNumber: 0, // number of impressions
            defaultDisplayType: '' //selected/all
        };
        const SOURCE_TYPE = {
            default: 1,
            gmb: 2,
            zillow: 3,
            rma: 4
        };
        return {
            ...config,
            noFold: false,
            SOURCE_TYPE_MAP: SOURCE_TYPE,
            defaultHeadUrl:
                '//cdn.chime.me/image/fs/sitebuild/2019116/23/original_72e3a651-bde9-4cce-bb7b-a392a84c64f6.jpeg',
            defaultImgSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/default-img.png',
        };
    },
    watch: {
        agentid: {
            immediate: true,
            handler(v) {
                // data Attributes agentId and ssr Attributes agentid be consistent ， Uniform use this.agentId
                if (v != -1) {
                    this.agentId = v;
                }
            }
        }
    },
    computed: {
        ...mapState(['testimonials', 'agent', 'agentid', 'displayMoreLink']),
        suitableImg() {
            return this.isMobileSize
                ? this.bgImgOpt.mobileSrc
                : this.bgImgOpt.src;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        isValidAgent() {
            return this.agentId !== null && this.agentId != -1;
        },
        useMoreHref() {
            return this.moreType == 'page'
                ? this.morePage
                : this.displayMoreLink;
        },
        useMoreTarget() {
            return this.moreTarget ? '_blank' : '_self';
        },
        formatSource() {
            let arr = [];
            this.source?.forEach?.(item => {
                arr.push(REVIEW_SOURCE_KEY[+item]);
            });
            return arr;
        }
    },
    mounted() {
        this.initRmaPixel();
    },
    methods: {
        ...mapActions({
            setTestimonals: SET_TESTIMONIALS,
            setAgent: SET_AGENT,
            setDisplayMorelink: SET_DISPLAY_MORELINK
        }),
        itemMoreLine(lineCount) {
            return this.source?.length === 1 &&
                this.source[0] == REVIEW_SOURCE['zillow']
                ? 1e3
                : lineCount;
        },
        toViewMore(item) {
            let url = this.useMoreHref;
            if (item.sourceType == REVIEW_SOURCE.rma && this.moreType == 'rmaLink') {
                url = item.reviewLink;
            }
            window.open(url, this.useMoreTarget);
        },
        getAgentInfo() {
            // TODO:  avoid  id =0  when  bug
            if (this.isValidAgent) {
                this.axiosIns
                    .post('/api-graphql', {
                        query: `{agent(id: ${this.agentId}){fullName,image,phone,position,externalUrl,license,longIntroduction,email,headShots{photoFiveByThree,photoOneByOne,photoThreeByFour},socialNetworks:agentSocialNetworks{id,url,socialNetwork}}}`
                    })
                    .then(res => {
                        const agent = (res.data && res.data.agent) || {};
                        // this.agent = agent;
                        this.setAgent(agent);
                    })
                    .catch(errorInfo => {
                        console.log(errorInfo);
                    });
            }
        },
        updateTestimonialsSort() {
            this.getTestimonials();
        },
        getTestimonials() {
            const { siteId } = getStore.call(this, 'page');
            let params = {
                sourceTypes: this.formatSource.join(','),
                pageNum: 1,
                pageSize: +this.displayNumber,
                _t: Date.now()
            };

            if (params.sourceTypes == 'DEFAULT') {
                params.pageSize = 10000;
                if (this.defaultDisplayType != 'all') {
                    params.reviewIds = this.ids.replace(/\$\{[^}]+\}/, '');
                }
            } else {
                params.pageSize =
                    this.displayType == 'all' ? 10000 : +this.displayNumber;
            }
            return this.axiosIns
                .get(`/open-api/site/${siteId}/reviews`, {
                    params
                })
                .then(res => {
                    this.setTestimonals(res?.data?.data);
                });
        },
        getLatestMoreLink() {
            const { siteId } = getStore.call(this, 'page');
            return this.axiosIns
                .get(`/open-api/site/${siteId}/review/configs`)
                .then(res => {
                    const list = res?.data || [];
                    let temp = this.moreLink;
                    if (this.moreType == 'zillowLink') {
                        const zillow = list.find(
                            item =>
                                item.sourceType == this.SOURCE_TYPE_MAP.zillow
                        );
                        zillow?.agentKeyword &&
                            (temp = `https://www.zillow.com/profile/${zillow.agentKeyword}/#reviews`);
                    } else if (this.moreType == 'rmaLink') {
                        const rma = list.find(
                            item => item.sourceType == this.SOURCE_TYPE_MAP.rma
                        );
                        rma?.agentKeyword &&
                            (temp = `https://www.ratemyagent.com/real-estate-agent/${rma.agentKeyword}/sales/overview`);
                    }
                    this.setDisplayMorelink(temp);
                });
        },
        initRmaPixel() {
            let oImage = document.createElement('img');
            oImage.className = "rma-init-img";
            oImage.style.display = "block";
            oImage.style.width = '0px';
            oImage.style.height = '0px';
            oImage.src = "https://trixels.ratemyagent.com.au/trixel/init";
            document.body.prepend(oImage);
        }
    },
    provide() {
        return { source: () => this.source };
    }
};
